import _get from 'lodash/get'
import {
  updatePaymentMethod,
} from './index'

export const SET_UPDATE_PAYMENT_ORDER_PROCESSING = 'SET_UPDATE_PAYMENT_ORDER_PROCESSING'
export const SET_UPDATE_PAYMENT_ORDER_DATA = 'SET_UPDATE_PAYMENT_ORDER_DATA'
export const SET_UPDATE_PAYMENT_ORDER_COMPLETE = 'SET_UPDATE_PAYMENT_ORDER_COMPLETE'
export const SET_UPDATE_PAYMENT_ORDER_ERROR = 'SET_UPDATE_PAYMENT_ORDER_ERROR'
export const RESET_UPDATE_PAYMENT = 'RESET_UPDATE_PAYMENT'

export function processPaymentMethodUpdate (options) {
  return async function processPaymentMethodUpdateThunk (dispatch) {
    dispatch(setUpdatePaymentOrderProcessing(true))
    try {
      const update = await updatePaymentMethod(options)
      const orderErrorCode = _get(update, ['data', 'errorCode']) ? _get(update, ['data', 'errorCode']) : true

      if (_get(update, 'success')) {
        dispatch(setUpdatePaymentOrderData(update))
      } else {
        dispatch(setUpdatePaymentOrderError(orderErrorCode))
      }
    } catch (e) {
      dispatch(setUpdatePaymentOrderError(true))
      throw e
    }
  }
}

export function setUpdatePaymentOrderError (data) {
  return {
    type: SET_UPDATE_PAYMENT_ORDER_ERROR,
    payload: data,
  }
}

export function setUpdatePaymentOrderData (data) {
  return {
    type: SET_UPDATE_PAYMENT_ORDER_DATA,
    payload: data,
  }
}

export function setUpdatePaymentOrderProcessing (data) {
  return {
    type: SET_UPDATE_PAYMENT_ORDER_PROCESSING,
    payload: data,
  }
}

export function setUpdatePaymentOrderComplete (data) {
  return {
    type: SET_UPDATE_PAYMENT_ORDER_COMPLETE,
    payload: data,
  }
}

export function resetUpdatePayment () {
  return {
    type: RESET_UPDATE_PAYMENT,
  }
}
